function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useCallback as $bnPw9$useCallback, useState as $bnPw9$useState, useRef as $bnPw9$useRef, useEffect as $bnPw9$useEffect } from "react";
import { useCallbackRef as $bnPw9$useCallbackRef } from "@radix-ui/react-use-callback-ref";
function $71cd76cc60e0454e$export$6f32135080cb4c3(_ref) {
  var prop = _ref.prop,
    defaultProp = _ref.defaultProp,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange;
  var _$71cd76cc60e0454e$va = $71cd76cc60e0454e$var$useUncontrolledState({
      defaultProp: defaultProp,
      onChange: onChange
    }),
    _$71cd76cc60e0454e$va2 = _slicedToArray(_$71cd76cc60e0454e$va, 2),
    uncontrolledProp = _$71cd76cc60e0454e$va2[0],
    setUncontrolledProp = _$71cd76cc60e0454e$va2[1];
  var isControlled = prop !== undefined;
  var value1 = isControlled ? prop : uncontrolledProp;
  var handleChange = $bnPw9$useCallbackRef(onChange);
  var setValue = $bnPw9$useCallback(function (nextValue) {
    if (isControlled) {
      var setter = nextValue;
      var value = typeof nextValue === 'function' ? setter(prop) : nextValue;
      if (value !== prop) handleChange(value);
    } else setUncontrolledProp(nextValue);
  }, [isControlled, prop, setUncontrolledProp, handleChange]);
  return [value1, setValue];
}
function $71cd76cc60e0454e$var$useUncontrolledState(_ref2) {
  var defaultProp = _ref2.defaultProp,
    onChange = _ref2.onChange;
  var uncontrolledState = $bnPw9$useState(defaultProp);
  var _uncontrolledState = _slicedToArray(uncontrolledState, 1),
    value = _uncontrolledState[0];
  var prevValueRef = $bnPw9$useRef(value);
  var handleChange = $bnPw9$useCallbackRef(onChange);
  $bnPw9$useEffect(function () {
    if (prevValueRef.current !== value) {
      handleChange(value);
      prevValueRef.current = value;
    }
  }, [value, prevValueRef, handleChange]);
  return uncontrolledState;
}
export { $71cd76cc60e0454e$export$6f32135080cb4c3 as useControllableState };